import React from 'react';

interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function Divider({ children, className = '', ...rest }: DividerProps) {
    const classes = ['slice-divider', className].filter(Boolean).join(' ');
    return (
        <div className={classes} {...rest}>
            <span>{children}</span>
        </div>
    );
}
